
export default function About() {
  return (
    <div className="container">   
      <div className="page">
        <section className='align_center'>
          <h2 >      
            About us
          </h2>
          <hr className='line' />        
          {/* <h4><i>Engineering Beyond Conventional Boundaries</i></h4> */}
        </section> 
    
        <div className="align_left" >
          <p>
            We are an Australian engineering and technology development initiative focused on exploring unconventional approaches to propulsion, power conversion, and mechanical systems.        
          </p>

          <p>
            Our work is driven by a simple principle: <b><i>   When technology hits its physical limits, tweaking fails. We need a new architecture. </i></b>
          </p>

          <p>We currently have two independent technology projects: V-Drive and V-Rotor.</p>

          <p>Our projects address very different engineering challenges, but each uses the same approach: identify a fundamental limitation, develop a new technical architecture, and validate the concept through engineering analysis and experimental testing.</p>

          <p>Our projects do not rely on the same operating principle, and they address different engineering problems.</p>

          <p><b>V-Drive asks:</b> &nbsp; can propulsion be generated in a fundamentally different way?</p>

          <p><b>V-Rotor asks:</b> &nbsp; can rotary power conversion be redesigned to overcome limitations of conventional vane architectures?</p>

          <p>The projects are united by a common engineering philosophy:</p>

          <ul>
            <li>Challenge the limitation.</li>
            <li>Design a different architecture.</li>
            <li>Build the prototype.</li>
            <li>Measure the result.</li>
            <li>Improve the design.</li>
          </ul>

          <hr className='line' />        

          <h4><i>From Concept to Evidence</i></h4>

          <p>We believe unconventional engineering ideas should ultimately be judged by evidence.

          For this reason, our development process is focused on progressive validation rather than relying solely on theoretical predictions.

          Our approach includes:
          </p>

          {/* <p><b>Concept → Mathematical Modelling → Engineering Design → Prototype → Testing → Independent Validation → Further Development</b></p>  */}

          Where appropriate, we seek collaboration with engineers, researchers, universities, testing organisations, industry partners, and technology investors.

          <hr className='line' />        

          <h4><i>Open to Collaboration</i></h4>

          <p>Our projects are at stages where collaboration can accelerate development. We are interested in working with organisations and individuals with expertise in:</p>

          <ul>
            <li>Mechanical engineering</li>
            <li>Aerospace engineering</li>
            <li>Fluid dynamics</li>
            <li>Thermodynamics</li>
            <li>Materials and manufacturing</li>
            <li>CFD and FEA</li>
            <li>Precision instrumentation</li>
            <li>Engine development</li>
            <li>Propulsion systems</li>
            <li>Prototype fabrication</li>
            <li>Independent testing</li>
            <li>Commercialisation and technology licensing</li>
          </ul>

          We are particularly interested in partners who can contribute engineering expertise, testing capability, manufacturing capability, independent validation, or strategic investment.


        </div>     
   </div>
  </div>
)}
